<template>
  <div class="input-modal-wrapper">
    <div class="input-modal">
      <form>
        <!-- INPUT -->
        <div v-if="isComingFromCompany">
          <label for="editInputField" class="input-label"></label>
          <div class="input-wrapper last-item">
            <span class="sienit">Z</span>
            <input id="editInputField" type="text" placeholder="Нова стойност" v-model="input">
          </div>
        </div>

        <div class="inputs" :class="{ 'hide': this.isComingFromCompany }">
          <!-- INPUT MATERIAL  -->
          <div class="input-and-label-wrapper" v-if="isComingFromMaterials">
            <label class="input-label" for="inputMaterialField">Материал</label>
            <div class="input-wrapper">
              <span class="sienit">U</span>
              <input
                ref="nameInput"
                id="inputMaterialField"
                type="text"
                placeholder="Материал"
                v-model="inputName"
              >
            </div>
          </div>

          <!-- INPUT ACTIVITY  -->
          <div class="input-and-label-wrapper" v-if="isComingFromActivities">
            <label class="input-label" for="inputActivityField">Дейност</label>
            <div class="input-wrapper">
              <span class="sienit">U</span>
              <input
                ref="nameInput"
                id="inputActivityField"
                type="text"
                placeholder="Дейност"
                v-model="inputName"
              >
            </div>
          </div>

          <!-- INPUT MECHANIZATION  -->
          <div class="input-and-label-wrapper" v-if="isComingFromMechanizations">
            <label class="input-label" for="inputActivityField">Механизация</label>
            <div class="input-wrapper">
              <span class="sienit">U</span>
              <input
                ref="nameInput"
                id="inputMechanizationField"
                type="text"
                placeholder="Механизация"
                v-model="inputName"
              >
            </div>
          </div>

          <!-- COMMON INPUTS -->
          <div
            class="input-and-label-wrapper"
            v-if="isComingFromMaterials || isComingFromActivities || isComingFromMechanizations"
          >
            <label class="input-label" for="inputActivityField">Мерна единица</label>
            <div class="input-wrapper">
              <span class="sienit">Z</span>
              <select id="inputUnitField" class="select" v-model="inputUnit">
                <option value="бр">бр</option>
                <option value="ден">ден</option>
                <option value="кг">кг</option>
                <option value="км">км</option>
                <option value="курс">курс</option>
                <option value="л">л</option>
                <option value="м">м</option>
                <option value="м2">м2</option>
                <option value="м3">м3</option>
                <option value="месечно">месечно</option>
                <option value="мл">мл</option>
                <option value="мсм">мсм</option>
                <option value="опак.">опак.</option>
                <option value="т">т</option>
                <option value="час">час</option>
                <option value="чч">чч</option>
              </select>
            </div>
          </div>

          <!-- <div
            class="input-and-label-wrapper"
            v-if="isComingFromMaterials || isComingFromActivities || isComingFromMechanizations"
          >
            <label class="input-label" for="inputActivityField">Цена (евро)</label>
            <div class="input-wrapper">
              <span class="sienit">Z</span>
              <input
                id="inputPriceField"
                type="number"
                min="0"
                placeholder="Цена (евро)"
                v-model="inputPrice"
              >
            </div>
          </div>-->
        </div>

        <div class="input-modal-actions">
          <div>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <!-- BUTTON ACCEPT FOR COMPANY/PROJECT/OBJECT/PART-->
            <button
              v-if="isComingFromCompany"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save()"
            >
              <span class="sienit">c</span>
              Редактирай
            </button>
            <!-- BUTTON ACCEPT FOR MATERIAL/ACTIVITY-->
            <button
              v-if="isComingFromActivities || isComingFromMaterials || isComingFromMechanizations"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="saveMaterialActivityOrMechanization()"
            >
              <span class="sienit">Y</span>
              Запази
            </button>
            <button class="btn btn-close" @click.prevent="close()">
              <span class="sienit">F</span>
              Отказ
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'inputForEdit',
    'isComingFromActivities',
    'isComingFromMaterials',
    'isComingFromMechanizations',
    'isComingFromCompany'
  ],
  data() {
    return {
      input: '',
      inputName: undefined,
      inputUnit: 'бр',
      inputPrice: 0
    };
  },
  methods: {
    // SAVE METHODS
    save() {
      if (!this.input) {
        this.$snotify.error('Моля, въведедете стойност');
      } else {
        this.$parent.$emit('saveEditInputModal', {
          value: this.input,
          where: this.inputForEdit.where
        });
        // this.$snotify.success("Успешно редактиране!");
      }
    },
    saveMaterialActivityOrMechanization() {
      if (this.inputValidatation()) {
        // Check for materials modal
        if (this.isComingFromMaterials) {
          this.$parent.$emit('saveMaterialActivityOrMechanization', {
            name: this.inputName,
            unit: this.inputUnit,
            price: this.inputPrice
          });
          this.close();
        }
        // Check for activities modal
        else if (this.isComingFromActivities) {
          this.$parent.$emit('saveMaterialActivityOrMechanization', {
            name: this.inputName,
            unit: this.inputUnit,
            price: this.inputPrice
          });
          this.close();
        }
        // Check for mechanizations modal
        else if (this.isComingFromMechanizations) {
          this.$parent.$emit('saveMaterialActivityOrMechanization', {
            name: this.inputName,
            unit: this.inputUnit,
            price: this.inputPrice
          });
          this.close();
        }
      }
    },
    // VALIDATE INPUTS
    inputValidatation() {
      if (!this.inputName) {
        let output = 'материал';

        if (this.isComingFromActivities) {
          output = 'дейност';
        } else if (this.isComingFromMechanizations) {
          output = 'механизация';
        }

        this.$snotify.error(`Въведете име на ${output}`);
        return false;
      }
      if (!this.inputUnit) {
        this.$snotify.error('Въведете мерна единица');
        return false;
      }
      if (this.inputPrice === undefined) {
        this.$snotify.error('Въведете цена');
        return false;
      }
      if (this.inputName && this.inputUnit && this.inputPrice !== undefined) {
        return true;
      }
    },
    close() {
      this.$parent.$emit('closeEditInputModal');
    }
  },
  mounted() {
    if (this.isComingFromCompany) {
      this.input = this.inputForEdit.value;
    } else {
      let tryFocus = true;
      while (tryFocus) {
        const input = this.$refs.nameInput;
        if (input) {
          input.focus();
          tryFocus = false;
        }
      }
    }
  }
};
</script>

<style scoped>
.input-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.input-modal {
  background-color: #fff;
  border-radius: 4px;
  border-top: 10px solid #942b10;
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
  width: 600px;
}
.input-modal-permissions {
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.input-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.invalid .sienit {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.inputs {
  display: flex;
  margin-top: 20px;
}
.input-and-label-wrapper {
  display: flex;
  flex-direction: column;
  margin-right: 1em;
  margin-bottom: 1em;
  width: 100%;
}
.input-and-label-wrapper:last-child {
  margin-right: 0;
}
.input-label {
  font-size: 11px;
}

.input-wrapper {
  width: 100%;
}
.last-item {
  margin-right: 0px;
  /* margin-bottom: 0px; */
}
.hide {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .btn.btn-close {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 650px) {
  .input-modal {
    width: 90%;
  }
}
@media screen and (max-width: 450px) {
  .inputs {
    flex-direction: column;
  }
  .input-wrapper {
    margin-right: 0px;
  }
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-close {
    margin-bottom: 10px;
  }
}
</style>
